<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd" :disabled="!canWrite">新增</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="openPage" :disabled="Status === 2 || !canWrite">单据选择</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="save" :disabled="Status === 2 || !canWrite">保存</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="handleDelete" :disabled="!isSave || Status === 2 || !canWrite">删除</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="reView" v-if="Status !== 2" :disabled="!isSave || !canReview">审核</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="cancelReView" v-if="Status === 2" :disabled="!isSave || !canReview">弃审</el-button>
        <el-dropdown style="margin-left: 4px">
          <el-button type="primary" :disabled="!isSave"> 联查<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
          <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
            <el-dropdown-item class="dropdown-item" @click.native="goJump(1)">加工单</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="primary" style="margin-left: 4px" :disabled="!isSave">打印</el-button>
        <el-button type="primary" @click="openSetField">明细字段</el-button>
      </div>
      <el-form :model="data" ref="form" :inline="true" :line-form="true" label-width="80px" status-icon>
        <el-row style="margin-top: 18px">
          <el-form-item label="单据日期:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.DocDate }}</span>
            <el-date-picker v-else v-model="data.DocDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px" @change="v => getPreviewNo(v)">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="单据编码:" required label-width="100px">
            <span style="display: inline-block; width: 180px" v-if="Mode == 0" class="detail-span">{{ data.DocNo }}</span>
            <el-input style="width: 180px" v-else v-model="data.DocNo" placeholder="请输入单据编码"></el-input>
          </el-form-item>
          <el-form-item label="业务类型:" label-width="100px">
            <span class="not-edit" style="width: 180px" v-if="Status === 2">{{ data.BusinessType }}</span>
            <el-select v-else v-model="data.BusinessTypeId" style="width: 180px">
              <el-option @click.native="BusinessChange(item)" v-for="item in businessTypeList" :key="item.BusinessTypeId" :label="item.BusinessType" :value="item.BusinessTypeId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓库:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.WarehouseName }}</span>
            <el-select v-else style="width: 180px" v-model="data.WarehouseId" @change="changeDataGeneralWarehouse">
              <el-option v-for="item in warehouseList" :key="item.key" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="加工类型:" label-width="100px">
            <span class="not-edit">{{ data.ProcessingType }}</span>
          </el-form-item>
          <el-form-item label="车间:" label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.WorkShopName }}</span>
            <v-select v-else style="width: 180px" ref="typeSelect" v-model="data.WorkShopId" />
          </el-form-item>
          <el-form-item label="经手人:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.EmpName }}</span>
            <select-input v-else placeholder="请选择经办人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" style="width: 180px" />
          </el-form-item>
          <el-form-item label="制单人" label-width="100px">
            <span class="span" style="width: 180px !important">{{ data.MakeEmpName }}</span>
          </el-form-item>
          <el-form-item label="入库类型:" label-width="100px">
            <span class="not-edit">按胶件入库</span>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注:" label-width="100px">
              <el-input type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" :disabled="Status === 2" style="width: 600px" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table key="table0" border class="table_bottom table-line tb-c-head" :row-class-name="tableRowClassName" :data="mouldData" stripe style="margin-top: 18px">
        <el-table-column label="加工单号" prop="SourceNo" align="left" min-width="110" />
        <el-table-column label="模号" prop="MouldNo" align="left" min-width="100" />
        <el-table-column label="模具名称" prop="MouldName" align="left" min-width="100" />
        <el-table-column :label="'需求重量' + '(' + NeedUnit + ')'" align="right" min-width="100">
          <template slot-scope="{ row }">
            <span>{{ ((row.Quantity * row.PerNetWeight) / NeedRate).toFixed(5) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="Quantity" align="right" min-width="100">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.Quantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="应入库数" prop="AnswerQuantity" align="right" min-width="100">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.AnswerQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="累计入库数" prop="TotalInQuantity" align="right" min-width="100">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.TotalInQuantity) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 底部表格 -->
      <el-table
        key="table1"
        border
        class="table_bottom table-line tb-c-head"
        :row-class-name="tableRowClassName"
        :data="tableData"
        @row-click="add_pro"
        stripe
        style="margin-top: 18px"
        v-if="showDetail"
      >
        <insert-row @on-insert="onInsert_pro" />
        <el-table-column min-width="160" align="left" label="备注" v-if="showField('备注')">
          <template slot-scope="{ row }">
            <span v-if="Status === 2">{{ row.Remark }}</span>
            <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
          </template>
        </el-table-column>
        <el-table-column label="加工单号" prop="SourceNo" align="left" min-width="120" key="table1_1" v-if="showField('加工单号')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ row.SourceNo }}</span>
            <el-input type="text" @input="ProceNumInput(row, $index)" v-model="row.SourceNo" v-else @change="changeQuantity($event, row, $index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="批号" prop="BatchNumber" align="left" min-width="120" v-if="showField('批号')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ row.BatchNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="生产部门" prop="WorkShopId" align="left" min-width="120" key="table1_13" v-if="showField('生产部门')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ row.WorkShopName }}</span>
            <v-select v-else style="width: 180px" :ref="'workShopSelect' + $index" v-model="row.WorkShopId" :is-init="false" @node-click="workShopChange($event, row)" :options="dpList" />
          </template>
        </el-table-column>
        <el-table-column label="仓库" prop="WarehouseId" align="left" min-width="120" key="table1_2" v-if="showField('仓库')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.WarehouseName }}</span>
            <el-select v-else v-model="row.WarehouseId" @change="changeWarehouse($event, row)">
              <el-option v-for="item in warehouseList" :key="item.key" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="存货名称" prop="ProductName" align="left" min-width="100" key="table1_3" v-if="showField('存货名称')">
          <template slot-scope="{ row, $index }">
            <span v-if="Status === 2">{{ row.ProductName }}</span>
            <el-select v-else v-model="row.ProductId" @change="onSelect_ProductName(row, $index)" @visible-change="onSelProduct(row)">
              <el-option v-for="item in row.Products" :key="item.ProductId" :label="item.ProductName" :value="item.ProductId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="存货条码" prop="Barcode" align="left" min-width="160" v-if="showField('存货条码')"> </el-table-column>
        <el-table-column label="存货编码" prop="ProductNo" align="left" min-width="160" key="table1_4" v-if="showField('存货编码')" />
        <el-table-column label="规格型号" prop="ProductSpec" align="left" min-width="100" key="table1_5" v-if="showField('规格型号')" />
        <el-table-column label="属性" prop="PropertyId" align="left" min-width="100" key="table1_6" v-if="showField('属性')">
          <template slot-scope="{ row }">
            <el-select v-if="(row.UseProcess && Status !== 2) || (Status !== 2 && row.PropertyId)" v-model="row.PropertyId" @change="changeProperty($event, row)">
              <el-option v-for="item in propertyList" :key="item.PropertyId" :label="item.PropertyName" :value="item.PropertyId"></el-option>
            </el-select>
            <span class="not-edit" v-else>{{ row.UseProcess ? row.PropertyName : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="颜色" prop="ColorId" align="left" min-width="100" key="table1_7" v-if="showField('颜色')">
          <template slot-scope="{ row }">
            <el-select v-if="(row.UseColor && Status !== 2) || (Status !== 2 && row.ColorId)" v-model="row.ColorId" @change="changeColor($event, row)">
              <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId"></el-option>
            </el-select>
            <span class="not-edit" v-else>{{ row.UseColor ? row.ColorName : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="装箱规格" prop="PackingSpeciId" align="left" min-width="100" v-if="showField('装箱规格')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{row.SpeciName}}</span>
            <el-select v-model="row.PackingSpeciId" v-else @change="changeSpeci($event, row)">
              <el-option v-for="item in packingspeciList" :key="item.PackingSpeciId" :label="item.SpeciName" :value="item.PackingSpeciId" :disabled="item.Status == 0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="每件数" prop="PackingNumber" align="left" min-width="100" v-if="showField('装箱数量')"></el-table-column>
        <el-table-column label="件数" prop="PackingQuantity" align="left" min-width="100" v-if="showField('件数')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.PackingQuantity) }}</span>
            <el-input type="text" v-else @change="changePackingQuantity($event, row, $index)" v-model="row.PackingQuantity"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="left" label="计量单位" min-width="120px" v-if="showField('计量单位')">
          <template slot-scope="{ row, $index }">
            <el-select v-if="row.Units && row.Units.length > 0 && row.HasGrammage != true" v-model="row.UnitId" :disabled="Status === 2">
              <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareSaUnit(item, row, $index)"></el-option>
            </el-select>
            <span v-else>{{ row.UnitName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="Quantity" align="right" min-width="100" key="table1_9" v-if="showField('数量')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity) }}</span>
            <el-input type="text" v-else @change="changeQuantity($event, row, $index)" v-model="row.Quantity"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="单价" prop="Price" align="right" min-width="100" key="table1_10" v-if="canPrice && showField('单价')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.Price }}</span>
            <el-input type="text" v-else @change="changePrice($event, row)" v-model="row.Price"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="金额" prop="Amount" align="right" min-width="100" key="table1_11" v-if="canPrice && showField('金额')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Amount) }}</span>
            <el-input type="text" v-else @change="changeAmount($event, row)" v-model="row.Amount"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="克重" prop="Grammage" align="right" min-width="100" v-if="showField('克重')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Grammage) }}</span>
            <el-input type="text" v-else @change="changeGrammage($event, row, $index)" v-model="row.Grammage"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="left" label="计量单位2" min-width="120px" v-if="showField('计量单位2')">
          <template slot-scope="{ row, $index }">
            <el-select v-if="row.Units && row.Units.length > 0 && row.HasGrammage != true" v-model="row.UnitId2" :disabled="Status === 2">
              <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareUnitId(item, row, $index)"></el-option>
            </el-select>
            <span v-else-if="row.UnitType == 0"></span>
            <span v-else>{{ row.UnitName2 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量2" prop="Quantity2" align="right" min-width="100" v-if="showField('数量2')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity2) }}</span>
            <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Quantity2" @change="changeQuantity2($event, row, $index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="单价2" prop="Price2" align="right" min-width="100" v-if="canPrice && showField('单价2')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.Price2 }}</span>
            <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Price2" @change="changePrice2($event, row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="right" label="换算率" v-if="showField('换算率')">
          <template slot-scope="{ row, $index }">
            <span v-if="(Status === 2 || row.ChangeType === 0) && row.UnitType == 1">{{ row.Rate }}</span>
            <span v-else-if="row.UnitType == 0"></span>
            <span v-else-if="row.HasGrammage == true">{{ row.Rate }}</span>
            <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
          </template>
        </el-table-column>        
              <el-table-column align="left" label="销售单号" min-width="120px" v-if="showField('销售单号')">
                <template slot-scope="{ row }">
                  <span>{{ row.OrderNo }}</span>
                </template>
              </el-table-column>
        <el-table-column label="应入库数" prop="AnswerQuantity" align="right" min-width="100" v-if="showField('应入库数')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.AnswerQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="累计入库数" prop="TotalInQuantity" align="right" min-width="100" v-if="showField('累计入库数')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.TotalInQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="Status !== 2" label="操作" fixed="right" align="center" min-width="140" key="table1_12">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="separate(row, $index)" v-if="row.ProductId > 0" :disabled="Status === 2">分箱</el-button>
            <el-button type="text" @click="del_pro1(row, $index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mtx10">
        <div class="flex space-between">
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核人</div>
            <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核时间</div>
            <div class="center el-form-item__label">{{ data.ReviewTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <edit-dialog ref="editDialog" @saved="saved" :Stage="stage" :OrderType="OrderType"></edit-dialog>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
    <separate-dialog ref="separateDialog" @saved="saveSeparate" :packingspeciList="packingspeciList"></separate-dialog>
  </div>
</template>
<script>
import editDialog from './editDialog'
import separateDialog from './separateDialog'
import accountSelect from '@/components/business/stock/select'
import mouldSelect from '@/components/production/clothmanagement/cloth/select'

//import vSelect from '@/components/business/stock/productionpicking/vSelect'
import empDialog from '@/components/personnel/result/record/listDialog'
import optionMixins from '@/mixins/option'
import fieldDialog from '@/components/common/fieldDialog'

export default {
  name: 'editinjectionmolding1',
  mixins: [optionMixins],
  components: {
    editDialog,
    accountSelect,
    //vSelect,
    mouldSelect,
    empDialog,
    fieldDialog,
    separateDialog
  },
  data() {
    return {
      pdApi: require('@/api/ba/product').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      businessTypeApi: require('@/api/ba/businessType').default,
      mouldApi: require('@/api/ba/mould').default,
      colorApi: require('@/api/ba/color').default,
      code_api: require('@/api/sy/serialCode').default,
      commonApi: require('@/api/common/common').default,
      api: require('@/api/stock/stInDoc').default,
      propertyApi: require('@/api/ba/property').default,
      docSetting_api: require('@/api/sy/docSetting').default,
      workDocApi: require('@/api/production/workDoc').default,
      dpApi: require('@/api/ent/dp').default,
      packingspeciApi: require('@/api/ba/packingspeci').default,
      propertyList: [],
      Mode: 0,
      colorList: [],
      businessTypeList: [],
      warehouseList: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      dpList: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      mouldHead: [
        { Value: 'MouldNo', Name: '模具编号', Width: '180' },
        { Value: 'MouldName', Name: '模具名称', Width: '150' }
      ],
      minitDAccount: [],
      minitTotal: 0,
      mDAccount: [],
      mlistTotal: 0,
      mpageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      viewType: 'create',
      Status: 0,
      data: {
        DocId: 0,
        InType: 1,
        DocDate: this.$commonJs.getToday(),
        DocNo: '',
        WorkShopId: 0,
        WorkShopName: '',
        BusinessTypeId: '',
        WarehouseId: '',
        WarehouseName: '',
        MinusEntry: '',
        EmpName: '',
        DictionaryId: 0,
        EmpId: 0,
        MakeEmpName: '',
        MakeEmpId: 0,
        ReviewEmpName: '',
        ReviewEmpId: 0,
        ReviewTime: '',
        ProcessingType: '',
        BusinessTypeNo: '',
        BusinessType: '',
        Remark: '',
        ItemValue: 0,
        ItemText: 1,
        SourceId: 0,
        SourceNo: '',
        SourceDtsId: 0,
        SourceType: 0,
        StorageMethod: 0 //0按胶件入库，1按模入库
      },
      tableType: '注塑',
      date: [],
      isSave: false,
      tableData: [],
      mouldData: [],
      delMouldData: [],
      delTableData: [],
      isUseProcess: true,
      isUseColor: true,
      stage: 0,
      OrderType: 0,
      NeedUnit: '斤',
      NeedRate: 500,
      detailFields: [],
      showDetail: false,
      SourceType: null,
      packingspeciList: []
    }
  },
  created() {
    this.NeedUnit = localStorage.getItem('NeedUnit')
    this.NeedRate = localStorage.getItem('NeedRate')
    this.init()
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/stock/productionshipping')
    },
    canWrite() {
      return this.$permission.canWrite('/business/stock/productionshipping')
    },
    canReview() {
      return this.$permission.canReview('/business/stock/productionshipping')
    }
  },
  mounted() {
    this.viewType = this.$route.params.type
    if (this.$route.params.type === 'create') {
      this.getPreviewNo()
      const user = this.$store.state.user
      if (user) {
        this.data.EmpId = user.empId
        this.data.EmpName = user.name
      }
    } else if (this.$route.params.type === 'edit') {
      this.editInit(this.$route.params.data)
    }
    this.sourceTypeApi.info('生产工单产品').then(res => {
      this.SourceType = res.SourceTypeId
    })
  },
  methods: {
    separate(row, index) {
      let o = {
        ...row,
        index
      }
      this.$refs.separateDialog.openEdit(o)
    },
    saveSeparate(data) {
      console.log(data, 'saved')
          if (data) {
        var checkData = this.tableData[data.index]
        this.tableData.splice(data.index, 1)
        if (checkData.DocProductId > 0) {
          this.delTableData.push({ ...checkData, T: 2, WarehouseId: checkData.WarehouseId ?? 0 })
        }
        console.log(this.tableData, 'this.tableData')
        var arr = []
        data.list.forEach(item => {
          let o = {
            ...item,
            DocId:0,
            DocProductId: 0,
            T: 0,
          }
          console.log(o, 'separate')
          arr.push(o)
        })
        this.tableData.unshift(...arr)
        // data.list.forEach(item => {
        //   this.tableData.push(item)
        // })

        this.tableData.forEach((i, d) => {
          i.index = d      
        })
      }
    },
    changePackingQuantity(val, row, index) {
      if (row.PackingNumber > 0) {
        if (val) {
          row.Quantity = parseInt(val * row.PackingNumber)
          if (row.HasGrammage == true) {
            row.Quantity2 = row.Quantity * row.Rate
          }
          if (this.data.ProcessingType === '注塑') {
            this.editMouldQua(row)
          }
        }
      }
    },
    changeSpeci(val, row) {
      let item = this.packingspeciList.filter(item => {
        return item.PackingSpeciId === val
      })[0]
      console.log(item, 'changeSpeci')
      if (item) {
        row.PackingNumber = item.PackingNumber
        row.RealPackingNumber = item.RealPackingNumber
        if (row.Quantity) {
          row.PackingQuantity = parseInt(row.Quantity / row.PackingNumber)
        }
      }
    },
    // 根据加工单号查询数据
    async ProceNumInput(row, index) {
      console.log('this.SourceType', this.SourceType)
      if (row.SourceNo.length >= 11) {
        //根据单号查询
        const res = await this.workDocApi.getDocList({ WorkDocNo: row.SourceNo })
        if (res.Data && res.Data.length > 0) {
          var doc = res.Data[0]
          console.log('getDocList', JSON.parse(JSON.stringify(doc)))
          if (doc.DpId) {
            row.WorkShopId = doc.DpId //单据的生产部门
          }
          this.workDocApi.info(doc.WorkDocId).then(res1 => {
            console.log('info', res1.Data)
            if (res1.Code == 0) {
              //PZ240123001
              var extraList = res1.Data.ProductModels
              if (extraList && extraList[0]) {
                let sourceNo = res1.Data.WorkDocNo
                let sourceId = res1.Data.WorkDocId
                let sourceDtsId = extraList[0].WorkDocProductId

                //模具对应的存货，用于下拉选择
                row.Products = extraList[0].BomRubbers.map(item => {
                  item.type = 1
                  item.InitQuantity = item.Quantity
                  if (this.docType === 1) {
                    item.Quantity = item.NeedQuanity - item.InQuantity
                  } else {
                    item.Quantity = item.NeedQuanity - item.DirectInQuantity
                  }
                  item.Barcode = item.BarCode
                  item.WorkDocNo = sourceNo
                  item.ProcessStage = 0
                  item.UnitId = item.SkUnitId
                  item.UnitName = item.SkUnitName
                  item._WorkDocProductId = sourceDtsId
                  item._WorkDocId = sourceId
                  item.SourceType = this.SourceType
                  return { ...item }
                })

                extraList.forEach(item => {
                  if (this.mouldData.findIndex(x => x.MouldId == item.MouldId) == -1) {
                    let { T, DocId = 0, DocMouldId = 0, Amount, MouldId, MouldName, PerNetWeight, MouldNo, Price, Quantity, WorkDocNo, TotalInQuantity, AnswerQuantity } = item

                    let o = {
                      T,
                      DocId,
                      DocMouldId,
                      Amount: Amount ?? 0,
                      MouldId,
                      MouldName,
                      MouldNo,
                      Price: Price ?? 0,
                      Quantity,
                      WorkDocNo,
                      PerNetWeight,
                      SourceId: item.WorkDocId,
                      SourceNo: item.WorkDocNo,
                      SourceDtsId: item.WorkDocProductId,
                      SourceType: this.SourceType,
                      childData: [],
                      TotalInQuantity,
                      AnswerQuantity
                    }
                    if (row.Products) o.childData = row.Products.map(x => ({ ...x, T: 0 }))
                    this.mouldData.unshift(o) //添加模具记录
                    console.log('this.mouldData', this.mouldData)
                  }
                })
              }
            }
          })
        }
      }
    },
    //更改克重
    changeGrammage(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') return
      console.log('row', row)
      this.editT(row)
      if (row.UnitType == 1) {
        if (row.HasGrammage == true) {
          row.Rate = Number((row.Grammage / row.Variable).toFixed(5))
          if (row.IsMain) {
            row.Quantity2 = this.getQuantity(row.Quantity * Number(row.Rate))
            console.log('row.IsMain1', row.IsMain, Number(row.Rate))
            if (type === 0) {
              row.Amount = this.setAmount(row.Price, row.Quantity)
            }
          } else {
            row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate))
            console.log('row.IsMain2', row.IsMain, Number(row.Rate))
          }
        }
      }
      if (this.data.ProcessingType === '注塑' && type === 0) {
        this.editMouldQua(row)
      }
    },
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({ DocType: '注塑入库单', Url: 'business/stock/injectionmolding/edit' })
      })
    },
    setTbField() {
      this.showDetail = false
      this.docSetting_api.list({ DocType: '注塑入库单', IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey)
          this.$nextTick(() => {
            this.showDetail = true
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1
    },
    //选仓库
    changeDataGeneralWarehouse(val) {
      let item = this.warehouseList.find(item => item.value === val)
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].T !== 0) {
          this.tableData[i].T = 1
        }
        this.tableData[i].WarehouseId = item.value
        this.tableData[i].WarehouseName = item.label
      }
    },
    //添加存货 - tableData
    onInsert_pro(e) {
      let { type, index } = e
      this.interpolate_pro(null, index, type)
    },
    interpolate_pro(row, index, type = '') {
      let o = {
        T: 0,
        WorkDocNo: '',
        WarehouseId: '',
        ProductName: '',
        ProductNo: '',
        ProductSpec: '',
        PropertyId: null,
        PropertyName: '',
        Colors: [],
        ColorId: null,
        ColorName: '',
        UnitId: null,
        UnitName: '',
        Units: [],
        Quantity: '',
        Price: '',
        Amount: '',
        SourceId: 0,
        SourceNo: '',
        SourceDtsId: 0,
        SourceType: 0,
        WorkShopId: '',
        Products: []
      }
      if (type == 'down') {
        index = index + 1
      }
      this.tableData.splice(index, 0, o)
      let copy = JSON.parse(JSON.stringify(this.tableData))
      this.tableData = []
      this.$nextTick(() => {
        this.tableData = copy
      })
      console.log('this.tableData', this.tableData)
    },
    /*添加经手人*/
    setEmp(data) {
      console.log(data)
      this.data.EmpId = data.EmpId
      this.data.EmpName = data.EmpName
    },
    openEmp() {
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },
    /**********/
    async goJump(index) {
      let params = {}
      let ids = []
      let res = null
      switch (index) {
        case 1:
          ids = this.tableData.filter(item => item.SourceType === 42).map(item => item.WorkDocId)
          if (ids.length === 0) {
            this.$message.error('单据未引用工单，无法进行联查')
          } else {
            params.Ids = ids
            params.ProductionType = 0
            this.$router.push({ name: 'workorder', params: params })
          }
          break
      }
    },
    getPreviewNo(dateTime = '') {
      this.code_api.previewNo('生产入库单', dateTime).then(res => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.data.DocNo = res.Data.PreviewNo
        } else {
          this.$message.warning('获取生产入库单编号失败')
        }
      })
    },
    editInit(data) {
      console.log('data', data)
      this.viewType = 'edit'
      this.isSave = true

      this.data.BusinessType = data.BusinessType
      this.data.BusinessTypeId = data.BusinessTypeId
      this.data.BusinessTypeNo = data.BusinessTypeNo
      this.data.DocDate = data.DocDate
      this.data.DocId = data.DocId
      this.data.DocNo = data.DocNo
      this.data.EmpId = data.EmpId
      this.data.EmpName = data.EmpName
      this.data.InType = data.InType
      this.data.MakeEmpId = data.MakeEmpId
      this.data.MakeEmpName = data.MakeEmpName
      this.data.ProcessingType = data.ProcessingType
      this.data.Remark = data.Remark
      this.data.ReviewEmpId = data.ReviewEmpId
      this.data.ReviewEmpName = data.ReviewEmpName
      this.data.ReviewTime = data.ReviewTime
      this.data.WarehouseId = data.WarehouseId !== 0 ? data.WarehouseId : null
      this.data.WarehouseName = data.WarehouseName
      this.data.WorkShopId = data.WorkShopId
      this.data.WorkShopName = data.WorkShopName

      this.tableType = data.ProcessingType

      this.Status = data.Status

      data.Moulds.forEach(item => {
        item.T = null
      })

      data.Products.forEach((item, i) => {
        item.T = null
        item.PropertyId = item.PropertyId !== 0 ? item.PropertyId : null
        item.ColorId = item.ColorId !== 0 ? item.ColorId : null
        item.WarehouseId = item.WarehouseId !== 0 ? item.WarehouseId : null
        item.UnitId = item.UnitId !== 0 ? item.UnitId : item.SkUnitId
        item.UnitName = item.UnitName !== '' ? item.UnitName : item.SkUnitName

        if (item.Barcode === '' || item.Barcode == null) {
          var colorNo = '0'
          var propertyNo = '0'
          if (item.ColorId > 0) {
            var color = item.Colors.find(x => x.ColorId == item.ColorId)
            if (color) {
              colorNo = color.ColorNo
            }
          }
          if (item.PropertyId > 0) {
            var property = this.propertyList.find(x => x.PropertyId == item.PropertyId)
            if (property) {
              propertyNo = property.PropertyNo
            }
          }
          item.Barcode = item.ProductNo + '*' + colorNo + '*' + propertyNo
        }

        item.isSource = item.SourceNo === '' || item.SourceNo == null ? false : true

        if (item.Units.length === 0) {
          item.UnitType = 0
          item.UnitId = item.UnitId ?? item.SkUnitId
          item.UnitName = item.UnitName ?? item.SkUnitName
          item.UnitId2 = 0
          // row.SaUnitName = e.SaUnitName;
          item.UnitName2 = ''
          item.Rate = 0
          item.Quantity2 = 0
        } else {
          item.UnitType = 1
          let index = this.getUnitIndex(3, item.Units, item.UnitId)
          let data = this.getUnitValue(item.Units, index)
          let assistIndex = 0
          let assistData = {}
          item.IsMain = data.IsMain
          // row.ChangeType1 = data.ChangeType;
          item.Units.forEach(v => {
            if (v.ChangeType == 1) item.ChangeType = v.ChangeType
          })

          if (item.UnitId2 == null || item.UnitId2 == 0) {
            if (data.IsMain) {
              assistIndex = this.getUnitIndex(2, item.Units)
              assistData = this.getUnitValue(item.Units, assistIndex)
              item.Rate = assistData.Rate.toFixed(5)
            } else {
              assistIndex = this.getUnitIndex(1, item.Units)
              assistData = this.getUnitValue(item.Units, assistIndex)
              item.Rate = data.Rate.toFixed(5)
            }
            item.UnitId2 = assistData.UnitId
            item.UnitName2 = assistData.UnitName
          }

          if (item.Quantity2 == null) {
            this.changeQuantity(item.Quantity, item, i)
          }
        }
      })

      if (data.Moulds) {
        if (data.Moulds.length > 0) {
          data.Moulds.forEach(item => {
            item.SourceNo = data.Products[0].SourceNo
          })
        }
      }
      this.mouldData = data.Moulds
      this.tableData = data.Products

      if (this.mouldData.length > 0) {
        this.tableData.forEach(item => {
          let v = this.mouldData.find(v => item.MouldId === v.MouldId)
          item.mouldRate = item.Quantity / v.Quantity
          item.Products = [
            {
              ProductId: item.ProductId,
              ProductName: item.ProductName
            }
          ]
        })
      }
      this.$nextTick(() => {
        // this.tableData.forEach((e, i) => {
        //   this.$refs['workShopSelect' + i].setData();
        // })
      })
      console.log('this.tableData:', this.tableData)
    },
    init() {
      this.callOptionApi()
      this.setTbField()

      this.newLine_pro() //打开时增加一条胶件明细

      this.dpApi.list({ Status: 1 }).then(res => {
        this.dpList = res.Data
      })

      this.commonApi.getDictionaryList({ Code: 'ProductStage' }).then(res => {
        if (res.Code === 0) {
          var process = res.Data.find(x => x.ItemText == '注塑')
          console.log('process', JSON.parse(JSON.stringify(process)))
          if (process) {
            this.data.ProcessingType = process.ItemText
            this.data.DictionaryId = process.DictionaryId
            this.data.ItemValue = process.ItemValue
          }
        }
      })

      this.packingspeciApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.packingspeciList = res.Data
        }
      })
      this.propertyApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.propertyList = res.Data
        }
      })

      this.pdApi.list({ Status: 1, ...this.pageParams }).then(res => {
        this.DAccount = res.Data
        this.initDAccount = res.Data
        this.listTotal = res.Count
        this.initTotal = res.Count
      })

      this.mouldApi.list({ Statuses: [1, 2], ...this.mpageParams }).then(res => {
        this.mDAccount = res.Data
        this.minitDAccount = res.Data
        this.mlistTotal = res.Count
        this.minitTotal = res.Count
      })

      this.warehouseApi.list({ Status: 1, WarehouseType: 1 }).then(res => {
        if (res.Code === 0) {
          if (this.viewType === 'create') {
            this.data.WarehouseId = res.Data[0].WarehouseId
            this.data.WarehouseName = res.Data[0].WarehouseName
          }
          this.warehouseList = res.Data.map(item => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId
            }
          })
        }
      })

      this.colorApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.colorList = res.Data.map(item => {
            return {
              key: item.ColorId,
              label: item.ColorName,
              value: item.ColorId
            }
          })
        }
      })

      this.sourceTypeApi.list({}).then(res => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data
          let index = this.SourceTypeIdArr.findIndex(item => item.SourceType == '生产入库单')
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId
          this.data.InType = SourceTypeId
          this.businessTypeApi.getSourceTypeToBusinessType(SourceTypeId).then(res => {
            if (res.Code == 0) {
              this.businessTypeList = res.Data
              if (this.viewType !== 'edit') {
                this.data.BusinessTypeId = this.businessTypeList[0].BusinessTypeId
                this.data.BusinessType = this.businessTypeList[0].BusinessType
                this.data.MinusEntry = this.businessTypeList[0].MinusEntry
                this.changeNumber(this.data.MinusEntry)
              } else {
                console.log('this.data.BusinessTypeId', this.data.BusinessTypeId)
                let item = this.businessTypeList.find(item => item.BusinessTypeId === this.data.BusinessTypeId)
                this.data.MinusEntry = item.MinusEntry
                this.changeNumber(this.data.MinusEntry)
              }
            }
          })
        }
      })
    },
    //选择业务类型
    BusinessChange(val) {
      this.data.BusinessTypeId = val.BusinessTypeId
      this.data.MinusEntry = val.MinusEntry
      this.data.BusinessType = val.BusinessType
      this.changeNumber(this.data.MinusEntry)
    },
    changeNumber(status) {
      if (status) {
        this.tableData.forEach((item, index) => {
          item.Quantity = item.Quantity > 0 ? 0 - item.Quantity : item.Quantity
          item.Quantity2 = item.Quantity2 > 0 ? 0 - item.Quantity2 : item.Quantity2
          item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity, item.Price)
          if (item.T !== 0) {
            item.T = 1
          }
        })
        this.mouldData.forEach((item, index) => {
          item.Quantity = item.Quantity > 0 ? 0 - item.Quantity : item.Quantity
          item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity, item.Price)
          if (item.T !== 0) {
            item.T = 1
          }
        })
      } else {
        this.tableData.forEach((item, index) => {
          item.Quantity = item.Quantity == null ? item.Quantity : Math.abs(item.Quantity)
          item.Quantity2 = item.Quantity2 == null ? item.Quantity2 : Math.abs(item.Quantity2)
          item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity, item.Price)
          if (item.T !== 0) {
            item.T = 1
          }
        })

        this.mouldData.forEach((item, index) => {
          item.Quantity = item.Quantity == null ? item.Quantity : Math.abs(item.Quantity)
          item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity, item.Price)
          if (item.T !== 0) {
            item.T = 1
          }
        })
      }
    },
    /** 点击下拉存货 */
    async onSelProduct(row) {
      console.log('this.workDocApi', this.workDocApi)
      console.log('row', row)
      let _Products = []
      await this.workDocApi.info(row.SourceId).then(res1 => {
        if (res1.Code == 0) {
          //PZ240123001
          var extraList = res1.Data.ProductModels
          if (extraList && extraList[0]) {
            let sourceNo = res1.Data.WorkDocNo
            let sourceId = res1.Data.WorkDocId
            let sourceDtsId = extraList[0].WorkDocProductId

            //模具对应的存货，用于下拉选择
            _Products = extraList[0].BomRubbers.map(item1 => {
              item1.type = 1
              item1.InitQuantity = item1.Quantity
              if (this.docType === 1) {
                item1.Quantity = item1.NeedQuanity - item1.InQuantity
              } else {
                item1.Quantity = item1.NeedQuanity - item1.DirectInQuantity
              }
              item1.Barcode = item1.BarCode
              item1.WorkDocNo = sourceNo
              item1.ProcessStage = 0
              item1.UnitId = item1.PdUnitId
              item1.UnitName = item1.PdUnitName
              item1._WorkDocProductId = sourceDtsId
              item1._WorkDocId = sourceId
              return { ...item1 }
            })
            console.log('_Products1111', _Products)
            this.tableData = this.tableData.map(item => {
              return {
                ...item,
                Products: _Products
              }
            })
          }
        }
      })
      // await this.workDocApi.info(row.SourceId).then(res => {
      //   var products = res.Data.ProductModels[0].Rubbers.map(item => {
      //     return {
      //       ProductId:item.ProductId,
      //       ProductName:item.ProductName
      //     }
      //   })
      //   this.tableData = this.tableData.map(item => {
      //     return {
      //       ...item,
      //       Products: products
      //     }
      //   })
      // })
      this.ProceNumInput(row)
      console.log('this.tableData:', this.tableData)
    },
    //选中存货
    onSelect_ProductName(row, index) {
      var e = row.Products.find(x => x.ProductId == row.ProductId)
      row.SourceId = e.type === 1 ? e._WorkDocId : e.WorkDocId
      // row.SourceNo = "";
      row.SourceDtsId = e.type === 1 ? e._WorkDocProductId : e.WorkDocProductId
      row.SourceType = this.SourceType

      row.Colors = []
      row.Units = []

      row.ColorId = e.ColorId
      row.PropertyId = e.PropertyId

      row.UnitName = e.UnitName
      row.ColorName = e.ColorName

      row.ProductName = e.ProductName
      row.ProductNo = e.ProductNo
      row.ProductId = e.ProductId
      row.ProductSpec = e.ProductSpec
      row.Colors = e.Colors
      row.Units = e.Units

      row.UseColor = e.UseColor
      row.UseProcess = e.UseProcess
      row.TotalInQuantity = e.InQuantity
      row.AnswerQuantity = e.AnswerQuantity
      // row.SourceType = 0;
      // row.Quantity = 0;
      // row.Price = 0;
      // row.Amount = 0;
      row.WarehouseId = this.data.WarehouseId
      row.WarehouseName = this.data.WarehouseName

      row.ChangeType = e.ChangeType
      row.UnitType = e.UnitType
      row.UnitId2 = e.UnitId2
      row.UnitId = e.UnitId !== 0 ? e.UnitId : e.SkUnitId

      row.IsBatchNumber = e.BatchNumber ? true : false
      row.BatchNumber = null
      row.HasGrammage = e.HasGrammage
      row.Grammage = e.Grammage
      row.Variable = e.Variable
      if (e.BarCode) {
        row.Barcode = e.BarCode
      } else {
        row.Barcode = e.ProductNo + '*0*0'
      }
      // let _isUseProcess = this.tableData.find((item) => {
      //   return item.UseProcess === true;
      // });

      // if (_isUseProcess == null) {
      //   this.isUseProcess = false;
      // } else {
      //   this.isUseProcess = true;
      // }

      // let _isUseColor = this.tableData.find((item) => {
      //   return item.UseColor === true;
      // });

      // if (_isUseColor == null) {
      //   this.isUseColor = false;
      // } else {
      //   this.isUseColor = true;
      // }

      if (e.Units.length === 0) {
        row.UnitId = e.UnitId !== 0 ? e.UnitId : e.SkUnitId
        row.UnitName = e.UnitName !== '' ? e.UnitName : e.SkUnitName
        row.UnitId2 = 0
        // row.SaUnitName = e.SaUnitName;
        row.UnitName2 = ''
        row.Rate = 0
        row.Quantity2 = 0
      } else {
        row.UnitType = 1
        e.Units.forEach(item => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType
        })
        if (row.UnitId) {
          let index = this.getUnitIndex(3, e.Units, row.UnitId)
          let data = this.getUnitValue(e.Units, index)
          let assistIndex = 0
          let assistData = {}
          row.IsMain = data.IsMain
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = assistData.Rate.toFixed(5)
          } else {
            assistIndex = this.getUnitIndex(1, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = data.Rate.toFixed(5)
          }
          row.UnitId2 = assistData.UnitId
          row.UnitName2 = assistData.UnitName
        } else {
          let untiLength = e.Units.length
          let mainData = []
          let noMainData = []
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.UnitId = mainData[0].UnitId
          row.UnitName = mainData[0].UnitName
          row.UnitId2 = noMainData[0].UnitId
          row.UnitName2 = noMainData[0].UnitName
          row.Rate = noMainData[0].Rate.toFixed(5)
          row.IsMain = true
        }
      }
      this.changeQuantity(this.tableData[index].Quantity, row, index, 1)
      console.log('row', JSON.parse(JSON.stringify(row)))
    },
    getUnitValue(arr, findIndex) {
      let data = {}
      data.UnitId = arr[findIndex].UnitId
      data.UnitName = arr[findIndex].UnitName
      data.IsMain = arr[findIndex].IsMain
      data.ChangeType = arr[findIndex].ChangeType
      data.Rate = arr[findIndex].Rate
      return data
    },
    compareSaUnit(data, row, index) {
      if (row.T === 3) row.T = 1

      this.editT(row)

      let lastIsMain = row.IsMain
      this.tableData[index].IsMain = data.IsMain
      let findIndex = 0
      if (row.UnitId == row.UnitId2) {
        let num = 0
        num = row.Quantity
        row.Quantity = row.Quantity2
        row.Quantity2 = num

        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex, data.Rate)
          // row.ChangeType1 = data.ChangeType;
          if (lastIsMain) {
            row.Quantity2 = row.Quantity
          }
          // row.Quantity = (row.Quantity2 / Number(data.Rate)).toFixed(5);
          row.Quantity = this.getQuantity(row.Quantity2 / Number(data.Rate))
        }
      }
      this.changeQuantity(this.tableData[index].Quantity, row, index, 1)

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity))
      row.Price = this.getPrice(val)

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2))
      row.Price2 = this.getPrice(val)
    },
    //传入数组 索引 返回对应的 id 和name index是table索引  findIndex 是当前主辅单位索引
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId2 = this.tableData[index].Units[findIndex].UnitId
      this.tableData[index].UnitName2 = this.tableData[index].Units[findIndex].UnitName
      // this.tableData[index].ChangeType2=this.tableData[index].Units[findIndex].ChangeType

      if (Rate > 0) {
        this.tableData[index].Rate = Rate
      }
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = '') {
      let index = 0
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex(el => el.IsMain == true)
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex(el => el.IsMain == false)
      } else {
        //获取当前传入id的索引
        index = arr.findIndex(el => id == el.UnitId)
      }
      return index
    },
    editMouldQua(row) {
      console.log('row', row)

      // 先确定最小比例
      let list = this.tableData.filter(item => item.MouldId === row.MouldId)
      const groupedSum = new Map()
      console.log('list', list)
      list.forEach(item => {
        if (!groupedSum.has(item.ProductId)) {
          groupedSum.set(item.ProductId, 0) // 初始化分组总和为0
        }
        if (item.UnitName == '个') {
          groupedSum.set(item.ProductId, groupedSum.get(item.ProductId) + Math.ceil(item.Quantity * item.mouldRate)) // 累加值
        } else {
          groupedSum.set(item.ProductId, groupedSum.get(item.ProductId) + Math.ceil(item.Quantity2 * item.mouldRate)) // 累加值
        }
      })
      const resultArray = Array.from(groupedSum, ([key, value]) => ({ id: key, qua: value }))
      resultArray.sort((a, b) => a.qua - b.qua)
      console.log(resultArray, 'resultArray')
      // //防止单位切换用斤去算那就完蛋  list[0].UnitName == "个"
      // let minQua = Math.ceil((list[0].UnitName == '个' ? list[0].Quantity : list[0].Quantity2) * list[0].mouldRate)
      // let length = list.length
      // for (let i = 1; i < length; ++i) {
      //   let qua = Math.ceil((list[i].UnitName == '个' ? list[i].Quantity : list[i].Quantity2) * list[i].mouldRate)
      //   if (minQua > qua) {
      //     minQua = qua
      //   }
      // }

      // // 获取id的模具，修改模具数量，并且修改金额
      // console.log('minQua', minQua, typeof minQua, resultArray[0].qua, typeof resultArray[0].qua)

      this.mouldData.forEach(item => {
        if (item.MouldId === row.MouldId) {
          item.Quantity = resultArray[0].qua
          item.Amount = Number((item.Quantity * item.Price).toFixed(5))
        }
      })
    },
    changeQuantity(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') {
        return
      }
      this.editT(row)

      if (this.data.MinusEntry) {
        row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2
        data = data > 0 ? 0 - data : data
      } else {
        row.Quantity = Math.abs(row.Quantity)
        row.Quantity2 = Math.abs(row.Quantity2)
        data = Math.abs(data)
      }
      if (row.T == 3) this.tableData[index].T = 1
      if (row.Units.length > 0) {
        if (row.IsMain) {
          // row.Quantity2= (row.Quantity / Number(row.Rate)).toFixed(5);
          //row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate))
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.Quantity * row.Rate)
          } else {
            row.Quantity2 = this.getQuantity(row.Quantity / row.Rate)
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.Quantity)
          }
        } else {
          // row.Quantity2 = this.getQuantity(data * Number(row.Rate))
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.SaQuantity / row.Rate)
          } else {
            row.Quantity2 = this.getQuantity(row.SaQuantity * row.Rate)
          }
          console.log('row.IsMain2', row.IsMain, this.getQuantity(row.Quantity / Number(row.Rate)))
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.Quantity)
          }
        }
      }

      if (this.data.ProcessingType === '注塑' && type === 0) {
        this.editMouldQua(row)
      }
      if (row.PackingSpeciId > 0) {
        if (row.PackingNumber > 0) {
          row.PackingQuantity = parseInt(row.Quantity / row.PackingNumber)
        }
      }
    },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1

      this.editT(row)

      let lastIsMain = row.IsMain
      if (data.IsMain) {
        this.tableData[index].IsMain = false
      } else {
        this.tableData[index].IsMain = true
      }
      let findIndex = 0
      if (row.UnitId == row.UnitId2) {
        let num = 0
        num = row.Quantity
        row.Quantity = row.Quantity2
        row.Quantity2 = num

        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          // row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          //  row.ChangeType2 = data.ChangeType;
        }
      } else {
        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          //  row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex, data.Rate)
          // row.ChangeType2 = data.ChangeType;
          if (!lastIsMain) {
            row.Quantity = row.Quantity2
          }
          // row.Quantity2 = (row.Quantity / Number(data.Rate)).toFixed(5);
          row.Quantity2 = this.getQuantity(row.Quantity / Number(data.Rate))
        }
      }
      this.changeQuantity2(this.tableData[index].Quantity2, row, index, 1)

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity))
      row.Price = this.getPrice(val)

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2))
      row.Price2 = this.getPrice(val)
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId = this.tableData[index].Units[findIndex].UnitId
      this.tableData[index].SaUnitName = this.tableData[index].Units[findIndex].UnitName
      // this.tableData[index].ChangeType1=this.tableData[index].Units[findIndex].ChangeType

      if (Rate > 0) {
        this.tableData[index].Rate = Rate
      }
    },
    changeQuantity2(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') {
        return
      }
      this.editT(row)
      // if(this.data.MinusEntry){
      //       row.Quantity2=0-row.Quantity2
      //      }else{
      //       row.Quantity2=Math.abs(row.Quantity2)
      //      }
      if (this.data.MinusEntry) {
        row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2
        data = data > 0 ? 0 - data : data
      } else {
        row.Quantity = Math.abs(row.Quantity)
        row.Quantity2 = Math.abs(row.Quantity2)
        data = Math.abs(data)
      }
      if (row.T === 3) row.T = 1
      if (row.IsMain == false) {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          //row.Rate = Math.abs(Number(data / row.Quantity)).toFixed(5)
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data))
            row.Price2 = this.getPrice(val)
          }
          if (row.HasGrammage == true) {
            row.Quantity = parseInt(this.getQuantity(data * row.Rate))
          } else {
            row.Rate = this.getIinvexchrate(data / row.Quantity)
          }
        } else {
          console.log('数量1=数量2/换算率')
          // row.Quantity=Number(data/row.Rate).toFixed(5);
          if (row.Quantity === 0) {
            row.Quantity = this.getQuantity(data * row.Rate)
          } else {
            row.Quantity = this.getQuantity(data / row.Rate)
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2)
          }
        }
      } else {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          //row.Rate = Math.abs(Number(row.Quantity / data)).toFixed(5)
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data))
            row.Price2 = this.getPrice(val)
          }
          if (row.HasGrammage == true) {
            row.Quantity = parseInt(this.getQuantity(data / row.Rate))
          } else {
            row.Rate = this.getIinvexchrate(row.Quantity / data)
          }
        } else {
          console.log('数量1=数量2*换算率')
          // row.Quantity=Number(data*row.Rate).toFixed(5);

          row.Quantity = this.getQuantity(data * row.Rate)
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2)
          }
        }
      }
      if (this.data.ProcessingType === '注塑' && type === 0) {
        this.editMouldQua(row)
      }
      if (row.PackingSpeciId > 0) {
        if (row.PackingNumber > 0) {
          row.PackingQuantity = parseInt(row.Quantity / row.PackingNumber)
        }
      }
    },
    changePrice(val, row) {
      this.editT(row)

      val = this.setNumber(val)
      row.Price = this.getPrice(val)
      row.Amount = this.setAmount(row.Price, row.Quantity)

      if (row.UnitId2 && row.Quantity2 !== 0) {
        row.Price2 = this.getPrice(row.Amount / row.Quantity2)
      }
    },
    changePrice2(val, row) {
      this.editT(row)

      val = this.setNumber(val)
      row.Price2 = this.getPrice(val)

      row.Amount = this.setAmount(row.Price2, row.Quantity2)
      if (row.Quantity !== 0) {
        row.Price = this.getPrice(row.Amount / row.Quantity)
      }
    },
    setAmount(p, q) {
      return Number((p * q).toFixed(5))
    },
    changeAmount(val, row) {
      this.editT(row)

      if (this.data.MinusEntry) {
        val = val > 0 ? 0 - val : val
      } else {
        val = Math.abs(val)
      }
      row.Amount = this.setNumber(val)

      if (row.Quantity !== 0) {
        row.Price = this.getPrice(Math.abs(row.Amount / row.Quantity))
      } else {
        this.$message({ type: 'warning', message: '数量不能为0' })
        row.Amount = 0
        return
      }

      console.log('row.Untis', row.Untis)
      if (row.Untis.length > 0) {
        if (row.Quantity2 !== 0) {
          row.Price2 = this.getPrice(Math.abs(row.Amount / row.Quantity2))
        } else {
          this.$message({ type: 'warning', message: '数量2不能为0' })
          row.Amount = 0
          return
        }
      }
    },
    editT(row) {
      if (row.T !== 0) row.T = 1
    },
    RateChange(data, row, index) {
      if (data < 0 || data == '') return
      this.editT(row)
      row.Rate = data
      row.Rate = Number(row.Rate).toFixed(5)
      // this.changeQuantity(this.tableData[index].Quantity,row,index)
      if (row.IsMain) {
        // row.Quantity2 = (row.Quantity / Number(data)).toFixed(5);
        row.Quantity2 = this.getQuantity(row.Quantity / Number(data))
      } else {
        // row.Quantity = (row.Quantity2 / Number(data)).toFixed(5);
        row.Quantity = this.getQuantity(row.Quantity2 / Number(data))
      }

      let val = this.setNumber(row.Amount / row.Quantity)
      row.Price = this.getPrice(val)

      val = this.setNumber(row.Amount / row.Quantity2)
      row.Price2 = this.getPrice(val)
    },
    changeColor(val, row) {
      this.editT(row)
      let item = row.Colors.find(item => item.ColorId === val)

      row.ColorNo = item.ColorNo
      row.ColorName = item.ColorName
      if (row.ProductId > 0) {
        row.Barcode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)
      }
    },
    changeProperty(val, row) {
      this.editT(row)
      let item = this.propertyList.find(item => item.PropertyId === val)
      row.PropertyNo = item.PropertyNo
      row.PropertyName = item.PropertyName
      if (row.ProductId > 0) {
        row.Barcode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)
      }
    },
    changeWarehouse(val, row) {
      this.editT(row)
      let item = this.warehouseList.find(item => item.value === val)
      row.WarehouseName = item.label
      if(!this.data.WarehouseId){
        this.data.WarehouseId=item.value;
      }
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    async openPage() {
      const res = await this.sourceTypeApi.info('生产入库单')
      this.OrderType = res.SourceTypeId

      let that = await this.$refs.editDialog.open()
      console.log('this.data.ItemText1111', this.data.ItemText)
      that.get_data({ Stage: this.data.ItemText - 1, ProductionType: 0 })
    },
    del_pro1(row, index) {
      console.log('del', JSON.parse(JSON.stringify(row)))

      this.$confirm('确认删除这条数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        if (row.T !== 0) {
          row.T = 2
          row.PropertyId = row.PropertyId ? row.PropertyId : 0
          row.ColorId = row.ColorId ? row.ColorId : 0
          row.WarehouseId = row.WarehouseId ? row.WarehouseId : 0
          row.UnitId = row.UnitId ? row.UnitId : 0
          this.delTableData.push(row)
        }

        this.tableData.splice(index, 1)

        //根据单号判断判断是否还存在其他同个单号的存货，如果不存在，则删除模具记录
        // if (this.tableData.findIndex(x => x.SourceNo == row.SourceNo) == -1) {
        //   this.mouldData = this.mouldData.filter(x => x.SourceNo != row.SourceNo);
        // }
        let list = this.tableData.filter(item => {
          return item.MouldId === row.MouldId
        })
        if (list.length === 0) {
          const index = this.mouldData.findIndex(i => i.MouldId === row.MouldId)
          if (index !== -1) {
            let mould = this.mouldData.find(item => item.MouldId === row.MouldId)
            if (mould.T !== 0) {
              mould.T = 2
              this.delMouldData.push(mould)
            }
            this.mouldData.splice(index, 1)
          }
        }

        if (this.tableData.length === 0) {
          this.newLine_pro()
        }
      })
    },
    newLine() {
      this.mouldData.push({
        T: 0,
        DocId: 0,
        DocMouldId: 0,
        WorkDocNo: '',
        MouldId: 0,
        MouldNo: '',
        MouldName: '',
        PerNetWeight: 0,
        Quantity: null,
        Price: null,
        Amount: null,
        SourceId: 0,
        SourceNo: '',
        SourceDtsId: 0,
        SourceType: 0,
        AnswerQuantity: null,
        TotalInQuantity: null
      })
    },
    newLine_pro() {
      this.tableData.push({
        T: 0,
        WorkDocNo: '',
        WarehouseId: '',
        ProductName: '',
        ProductNo: '',
        ProductSpec: '',
        PropertyId: null,
        PropertyName: '',
        Colors: [],
        ColorId: null,
        ColorName: '',
        UnitId: null,
        UnitName: '',
        Units: [],
        Quantity: null,
        Price: null,
        Amount: null,
        SourceId: 0,
        SourceNo: '',
        SourceDtsId: 0,
        SourceType: 0,
        AnswerQuantity: null,
        TotalInQuantity: null,

        UnitId2: null,
        UnitName2: '',
        Quantity2: 0,
        Price2: 0,
        Rate: 0,
        Remark: '',
        Products: []
      })
    },
    add_pro(row, column) {
      if (column.label === '操作' || this.Status === 2) {
        return
      }
      console.log('add_pro')
      if (row.index === this.tableData.length - 1) {
        this.newLine_pro()
      }
    },
    getMouldData(data) {
      let mouldData = []
      data = data.filter(item => item.MouldId !== 0)

      data.forEach(item => {
        let { T, DocId = 0, DocMouldId = 0, Amount, MouldId, MouldName, PerNetWeight, MouldNo, Price, Quantity, WorkDocNo, SourceId, SourceNo, SourceDtsId, SourceType } = item

        Price = Price ?? 0
        Amount = Amount ?? 0

        let o = {
          T,
          DocId,
          DocMouldId,
          Amount,
          MouldId,
          MouldName,
          MouldNo,
          Price,
          Quantity,
          WorkDocNo,
          PerNetWeight,
          SourceId,
          SourceNo,
          SourceDtsId,
          SourceType
        }

        mouldData.push(o)
      })

      return mouldData
    },
    getProductsData(data) {
      let Products = []
      data.forEach(item => {
        let {
          T,
          DocId = 0,
          DocProductId = 0,
          ProductId,
          Amount,
          ColorId,
          ColorName,
          Colors,
          Price,
          ProductName,
          ProductNo,
          ProductSpec,
          PropertyId,
          PropertyName,
          Quantity,
          UnitId,
          UnitName,
          Units,
          WarehouseId,
          WorkDocNo,
          WarehouseName,
          SourceId,
          SourceNo,
          SourceDtsId,
          SourceType,
          MouldId,

          UnitId2,
          UnitName2,
          Quantity2,
          Price2,
          Rate,

          UseColor,
          UseProcess,
          Remark,
          WorkShopId,
          WorkShopName,
          BatchNumber,
          BatchStartDate,
          Grammage,
          PackingQuantity,
          PackingSpeciId,
          Barcode,
          RealPackingNumber,OrderNo
        } = item

        PropertyId = PropertyId ? PropertyId : 0
        ColorId = ColorId ? ColorId : 0
        WarehouseId = WarehouseId ? WarehouseId : 0
        UnitId = UnitId ? UnitId : 0
        UnitId2 = UnitId2 ? UnitId2 : 0
        Price = Price ?? 0
        Amount = Amount ?? 0
        MouldId = MouldId ?? 0

        let o = {
          T,
          DocId,
          DocProductId,
          ProductId,
          Amount,
          ColorId,
          ColorName,
          Colors,
          Price,
          ProductName,
          ProductNo,
          ProductSpec,
          PropertyId,
          PropertyName,
          Quantity,
          UnitId,
          UnitName,
          Units,
          WarehouseId,
          WorkDocNo,
          WarehouseName,
          SourceId,
          SourceNo,
          SourceDtsId,
          SourceType,

          UnitId2,
          UnitName2,
          Quantity2,
          Price2,
          Rate,
          MouldId,

          WorkShopId,
          WorkShopName,
          UseColor,
          UseProcess,
          Remark,
          BatchNumber,
          BatchStartDate,
          Grammage,
          PackingQuantity,
          PackingSpeciId,
          Barcode,
          RealPackingNumber,OrderNo
        }

        Products.push(o)
      })

      return Products
    },
    save(type = 0) {
      //验证表单是否填写
      let yanzheng = ['DocDate', 'DocNo', 'BusinessTypeId', 'WarehouseId', 'ProcessingType', 'EmpId']
      for (let key in this.data) {
        if (yanzheng.indexOf(key) !== -1 && !this.data[key]) {
          this.$message({ type: 'warning', message: '表单未填写完整' })
          return
        }
      }
      if (this.data.WarehouseId == 0 || this.data.WarehouseId == null) return this.$message.warning('请先选择仓库')

      let Moulds = this.getMouldData(this.mouldData)
      let Products = this.getProductsData(this.tableData)
      console.log('products', Products)
      if (Products.length > 0 && Products[0].ProductName != '') {
      } else {
        this.$message({ type: 'warning', message: '明细列表不能为空' })
        return
      }
      Moulds = Moulds.filter(item => {
        return item.T != null && item.MouldId !== 0 && item.MouldId != null
      })

      Products = Products.filter(item => {
        return item.T != null && item.ProductId !== 0 && item.ProductId != null
      })

      var btId = 0
      var obj = this.businessTypeList.find(x => x.BusinessType == '采购退货')
      if (obj) btId = obj.BusinessTypeId

      let ProductsLength = Products.length
      for (let i = 0; i < ProductsLength; ++i) {
        if (this.data.BusinessTypeId == btId && btId) {
          if (Products[i].Amount > 0) {
            this.$message({ type: 'warning', message: '金额不能大于0' })
            return
          }
        } else {
          if (Products[i].Amount < 0) {
            this.$message({ type: 'warning', message: '金额不能小于0' })
            return
          }
        }
        if(Products[0].WarehouseId == 0 ||Products[0].WarehouseId==null){
            this.$message.warning('请先选择仓库')
            return
        }
        if (Products[i].UseColor && Products[i].ColorId === 0) {
          this.$message.error(`存货${Products[i].ProductName}未填写颜色`)
          return
        }
        
        // if (Products[i].UseProcess && Products[i].PropertyId === 0) {
        //   this.$message.error(`存货${Products[i].ProductName}未填写属性`)
        //   return
        // }
        if (Products[i].Quantity === 0 || Products[i].Quantity == null) {
          this.$message({
            type: 'warning',
            message: `请填写${Products[i].ProductName}的数量`
          })
          return
        }
      }

      Products = Products.concat(this.delTableData)

      // let MouldsLength = Moulds.length;
      // for (let i = 0; i < MouldsLength; ++i) {
      //   if (!Moulds[i].Quantity) {
      //     this.$message({ type: "warning", message: "请填写模具数量" });
      //     return;
      //   }
      // }

      Moulds = Moulds.concat(this.delMouldData)

      this.data.WorkShopId = this.data.WorkShopId ?? 0
      let o = {
        Moulds,
        Products,
        ...this.data
      }
      console.log('o', o)

      this.api.save(o).then(res => {
        if (res.Code === 0) {
          if (this.viewType === 'create') {
            this.data.DocId = res.Data
          }
          if (type !== 1) {
            this.$message.success(res.Msg)
          }
          this.isSave = true

          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              if (type === 1) {
                this.reView1()
              } else {
                this.editInit(res.Data)
              }
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    async saved({ subList, extraList }) {
      console.log('sublist=====', subList, 'extralist=====', extraList)
      extraList = extraList.filter(item => item.MouldId !== 0)
      let arr = []
      const res = await this.sourceTypeApi.info('生产工单产品')
      let SourceType = res.SourceTypeId

      let _MouldId = null
      let _MouldName = ''
      let _Quantity = null

      extraList.forEach(item => {
        let {
          T,
          DocId = 0,
          DocMouldId = 0,
          Amount,
          MouldId,
          MouldName,
          PerNetWeight,
          MouldNo,
          Price,
          Quantity,
          WorkDocNo,
          SourceId = item.WorkDocId,
          SourceNo = item.WorkDocNo,
          SourceDtsId = item.WorkDocProductId,
          SourceType,
          TotalInQuantity,
          AnswerQuantity
        } = item
        SourceDtsId = item.WorkDocProductId

        Price = Price ?? 0
        Amount = Amount ?? 0

        _MouldId = MouldId
        _MouldName = MouldName
        _Quantity = Quantity

        let o = {
          T,
          DocId,
          DocMouldId,
          Amount,
          MouldId,
          MouldName,
          MouldNo,
          Price,
          Quantity,
          WorkDocNo,
          PerNetWeight,
          SourceId,
          SourceNo,
          SourceDtsId,
          SourceType,
          TotalInQuantity,
          AnswerQuantity
        }
        o.childData = subList || []
        this.mouldData.unshift(o)
      })

      console.log('extraList', extraList)
      subList.forEach(item => {
        let o = {
          T: 0,
          DocId: 0,
          DocProductId: 0,
          WorkDocNo: item.WorkDocNo,
          SiteWarehouseId: null,
          GeneralWarehouseId: null,
          SiteWarehouseName: '',
          GeneralWarehouseName: '',
          ProductId: item.ProductId,
          ProductNo: item.ProductNo,
          ProductName: item.ProductName,
          ProductSpec: item.ProductSpec,
          PropertyId: item.PropertyId || 0,
          PropertyName: item.PropertyName || '',
          ColorId: item.ColorId || 0,
          ColorName: item.ColorName || '',
          Colors: item.Colors || [],
          Units: item.Units || [],
          UseProcess: item.UseProcess,
          UseColor: item.UseColor,
          UnitId: item.UnitId,
          UnitName: item.UnitName,
          Quantity: item.Quantity,
          mouldRate: ((item._MouldQuantity ? item._MouldQuantity : _Quantity) / item.Quantity).toFixed(5),
          Price: 0,
          Amount: 0,
          WarehouseId: this.data.WarehouseId,
          WarehouseName: this.data.WarehouseName,
          SourceId: item.type === 1 ? item._WorkDocId : item.WorkDocId,
          SourceNo: item.WorkDocNo,
          SourceDtsId: item.type === 1 ? item._WorkDocProductId : item.WorkDocProductId,
          SourceType: SourceType,
          MouldName: item.MouldName ? item.MouldName : _MouldName,
          MouldId: item.MouldId ? item.MouldId : _MouldId,

          UnitId2: null,
          UnitName2: '',
          Quantity2: 0,
          Price2: 0,
          Rate: 0,
          Grammage: item.Grammage,
          WorkShopId: item.WorkShopId,
          WorkShopName: item.WorkShopName,
          Products: [],
          TotalInQuantity: item.InQuantity,
          AnswerQuantity: item.AnswerQuantity,
          HasGrammage: item.HasGrammage,
          Variable: item.Variable,
          SkUnitId: item.SkUnitId,
          SkUnitName: item.SkUnitName,
          BatchNumber: item.BatchNumber,
          PackingQuantity: null,
          PackingSpeciId: null,
          OrderNo:item.OrderNo
        }
        arr.push(o)
      })
      arr.forEach((item, i) => {
        this.workDocApi.info(item.SourceId).then(res1 => {
          if (res1.Code == 0) {
            //PZ240123001
            var extraList = res1.Data.ProductModels
            if (extraList && extraList[0]) {
              let sourceNo = res1.Data.WorkDocNo
              let sourceId = res1.Data.WorkDocId
              let sourceDtsId = extraList[0].WorkDocProductId
              console.log('extraList[0].BomRubbers', extraList[0].BomRubbers)
              //模具对应的存货，用于下拉选择
              item.Products = extraList[0].BomRubbers.map(item1 => {
                item1.type = 1
                item1.InitQuantity = item1.Quantity
                if (this.docType === 1) {
                  item1.Quantity = item1.NeedQuanity - item1.InQuantity
                } else {
                  item1.Quantity = item1.NeedQuanity - item1.DirectInQuantity
                }
                item1.Barcode = item1.BarCode
                item1.WorkDocNo = sourceNo
                item1.ProcessStage = 0
                item1.UnitId = item1.UnitId
                item1.UnitName = item1.UnitId
                item1._WorkDocProductId = sourceDtsId
                item1._WorkDocId = sourceId
                return { ...item1 }
              })
            }
          }
        })
        item.isSource = item.SourceNo === '' || item.SourceNo == null ? false : true

        item.UnitType = 0
        item.ChangeType = 0
        // item.Units.forEach(v=>{
        //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
        // })
        if (item.Units.length === 0) {
        } else {
          item.UnitType = 1
          // if (item.UnitId != item.SkUnitId) {
          //     if (item.Units.filter(x => x.IsMain && x.UnitId == item.UnitId).length > 0) {
          //         item.Quantity = item.Quantity / item.Units.find(x => !x.IsMain && x.UnitId == item.SkUnitId).Rate;
          //     } else {
          //         item.Quantity = item.Quantity * item.Units.find(x => !x.IsMain && x.UnitId == item.UnitId).Rate;
          //     }
          //     item.UnitId = item.SkUnitId;
          //     item.UnitName = item.SkUnitName;
          // }
          let index = this.getUnitIndex(3, item.Units, item.UnitId)
          let data = this.getUnitValue(item.Units, index)
          let assistIndex = 0
          let assistData = {}
          item.IsMain = data.IsMain
          item.UnitName = data.UnitName
          // row.ChangeType1 = data.ChangeType;
          item.Units.forEach(item2 => {
            if (item2.ChangeType == 1) item.ChangeType = item2.ChangeType
          })
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, item.Units)
            assistData = this.getUnitValue(item.Units, assistIndex)
            item.Rate = assistData.Rate.toFixed(5)
          } else {
            assistIndex = this.getUnitIndex(1, item.Units)
            assistData = this.getUnitValue(item.Units, assistIndex)
            item.Rate = data.Rate.toFixed(5)
          }
          item.UnitId2 = assistData.UnitId
          item.UnitName2 = assistData.UnitName
          // row.ChangeType2 = assistData.ChangeType;
        }

        this.changeQuantity(arr[i].Quantity, item, i, 1)
      })
      this.tableData.unshift(...arr)
      this.$nextTick(() => {
        this.$refs.workShopSelect0.setData()
      })
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: 'warning', message: '请先进行保存再操作' })
        return
      } else {
        Object.assign(this.$data, this.$options.data.call(this))
        this.getPreviewNo()
        this.data.EmpId = this.$commonJs.empId()
        this.data.EmpName = this.$commonJs.userName()
        this.$route.params.type = 'create'
        this.viewType = 'create'
        this.init()
        this.isSave = false
      }
    },
    handleDelete() {
      let id = this.data.DocId
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.api.delete(id).then(res => {
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.newAdd()
            // this.$emit('deleted')
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
      })
    },
    reView1() {
      let id = this.data.DocId
      this.api.examine(id).then(res => {
        if (res.Code === 0) {
          this.$message({ type: 'success', message: res.Msg })
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              this.editInit(res.Data)
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    reView() {
      this.save(1)
    },
    cancelReView() {
      let id = this.data.DocId
      this.api.cancelExamine(id).then(res => {
        if (res.Code === 0) {
          this.$message({ type: 'success', message: res.Msg })
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              this.editInit(res.Data)
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    workShopChange(e, row) {
      row.WorkShopName = e ? e.DpName : ''
      this.editT(row)
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;
  .text {
    width: 60px;
  }
}
.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}
.span {
  display: inline-block;
  width: 180px;
}
.w180 {
  width: 180px;
}
.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  background-color: #eef1f6;
  border-color: #d1dbe5;
}
</style>
